'use strict';
import { cn_slab_opening } from '../model/cn_slab_opening';
import { cn_slab_type } from '../model/cn_slab_type';
import { cn_vertex } from '../model/cn_vertex';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_type_pastille } from './cn_type_pastille';
import { cn_edit_box } from './cn_edit_box';
import { cn_clone } from '../utils/cn_utilities';
import { cn_polygon_handler } from './cn_polygon_handler';
import { cn_svg_map } from './cn_svg_map';
import { cn_scene } from '../model/cn_scene';
import { cn_roof } from '../model/cn_roof';

export class cn_slab_opening_handler extends cn_edition_handler {
    //***********************************************************************************
    /**
     * Constructor
     * @param {Array<cn_slab_opening>} slab_openings
     * @param {cn_svg_map} map
     */
    constructor(slab_openings, map) {
        super(slab_openings, map);

        this._map = map;
        this._scene = slab_openings[0].parent;
        let is_roof = (this._scene.constructor == cn_roof);
        var transaction_manager = map._building.transaction_manager;

        this.slab_opening = (slab_openings.length == 1) ? slab_openings[0] : null;
        this._polygon_handler = null;
        if (this.slab_opening) {
            const polygon_handler = new cn_polygon_handler(this, this.slab_opening.contours[0].vertices.map(v => cn_clone(v.position)), true);
            this._handlers.push(polygon_handler);
            this._polygon_handler = polygon_handler;

            polygon_handler.snap_elements = (!is_roof)?this._scene.spaces:[];
            const lower_storey = map._storey.get_relative_storey(-1);
            if (lower_storey) polygon_handler.snap_elements = polygon_handler.snap_elements.concat(lower_storey.scene.stairs);

            var obj = this;
            obj._pending_changes = false;

            polygon_handler.on('change', () => {
                transaction_manager.push_transaction('Modification de trémie', obj.slab_opening.ID, () => {
                    obj._scene.update();
                    obj._scene.update_deep();
                });
                transaction_manager.push_item_set(obj.slab_opening.contours[0], 'vertices');

                var slab_opening_vertices = obj.slab_opening.contours[0].vertices;
                var handler_vertices = polygon_handler.vertices;

                while (slab_opening_vertices.length < handler_vertices.length)
                    slab_opening_vertices.push(new cn_vertex([0, 0]));

                if (slab_opening_vertices.length > handler_vertices.length)
                    slab_opening_vertices.splice(0, slab_opening_vertices.length - handler_vertices.length);

                for (var i = 0; i < handler_vertices.length; i++)
                    slab_opening_vertices[i] = new cn_vertex(handler_vertices[i]);

                obj._pending_changes = true;
            });
            polygon_handler.on('force_update', () => {
                obj._force_update();
            });
        }

        this._edit_box = new cn_edit_box(this, slab_openings, this._readOnly);

        let is_roof_slab_opening = slab_openings[0].is_roof();
        let coherent = !slab_openings.some(so => so.is_roof() != is_roof_slab_opening);

        //*** Type pastille */
        if (coherent) {
            if (is_roof_slab_opening) {
                const type_pastille = new cn_type_pastille(slab_openings, 'slab_type', () => map._building.get_roof_types(), 'Type de toiture', this._map);
                type_pastille.title = 'Modifier le type de découpe';
                this._edit_box.add_pastille(type_pastille);
            }
            else {
                const type_pastille = new cn_type_pastille(slab_openings, 'slab_type', () => map._building.get_floor_types(), 'Type de dalle', this._map);
                type_pastille.title = 'Modifier le type de découpe';
                type_pastille.null_element_type = new cn_slab_type(map._building);
                type_pastille.null_element_type.is_null = true;
                this._edit_box.add_pastille(type_pastille);
            }
        }

        if (!this._readOnly) {
            this._edit_box.add_lock_pastille(transaction_manager);
        }
        this._handlers.push(this._edit_box);
    }

    draw(camera) {
        if (this._polygon_handler) {
            this._polygon_handler.visible = this._polygon_handler.active = (!this.slab_opening.locked);
        }
        return super.draw(camera);
    }

    move(mouse_event) {
        if (this._pending_changes) this._force_update();
        return super.move(mouse_event);
    }

    drop(mouse_event) {
        if (this._pending_changes) this._force_update();
        return super.drop(mouse_event);
    }

    _force_update() {
        this._scene.update();
        this._scene.update_deep();
        this._map._storey.update_slabs();
        this._map.refresh();
        this._pending_changes = false;
    }
}

